<template>
  <footer class="browse_footer">
    <div class="footer_container">
      <div class="footer_about">
        <div class="about_us">
          <template v-if="appConfig.isAvglDomain">
            <a class="about_logo" :href="routeHome()" style="width: 90px">
              <i class="sp-ic-md-avgl_logo-theme" style="width: 90px; height: 30px;" />
            </a>
            <div class="about_info">Copyright © 2023, AVGL</div>
          </template>
          <template v-else>
            <a class="about_logo" :href="routeHome()">
              <i class="sp-ic-md-logo-v2-theme" />
            </a>
            <div class="about_info">Copyright © 2023, BoomTV</div>
          </template>
        </div>
        <div class="about_links">
          <template v-if="appConfig.isAvglDomain">
            <a class="about_link" :href="routeTerms()">Terms and Conditions</a>
            <a class="about_link" :href="routePrivacy()">Privacy</a>
            <a class="about_link" :href="routeDMCA()">DMCA</a>
            <a class="about_link" :href="routeAllFAQ()">FAQ</a>
            <a class="about_link" :href="routeAbout()">About</a>
            <a class="about_link" :href="appConfig.discordBoom">Contact</a>
          </template>
          <template v-else>
            <a class="about_link" :href="routeTerms()">Terms and Conditions</a>
            <a class="about_link" :href="routePrivacy()">Privacy</a>
            <a class="about_link" :href="routeOfficialRules()">Official Rules</a>
            <a class="about_link" :href="routeDMCA()">DMCA</a>
            <a class="about_link" :href="routeFAQ()">FAQ</a>
            <a class="about_link" :href="routeAbout()">About</a>
            <a class="about_link" :href="routeContact()">Contact</a>
            <!-- <a class="about_link" href="{{url('/about')}}">VR Ready</a> -->
          </template>
        </div>

        <div class="about_links personal_data">
          <a class="about_link" :href="routePersonalData()">Do Not Sell My Personal Information</a>
        </div>

      </div>
      <div class="footer_social">
        <div class="social_title">Find us on</div>
        <div class="social_links">
          <template v-if="appConfig.isAvglDomain">
            <a class="social_link" href="https://www.twitch.tv/avgl" target="_blank">
              <img class="lazyload" :data-src="contentCloudFront('/assets/v4/social_icon/twitch.png')" width="18" height="18">
            </a>
            <a class="social_link" href="https://discord.gg/avglofficial" target="_blank">
              <img class="lazyload" :data-src="contentCloudFront('/assets/v4/social_icon/discord.png')" width="16.442" height="18">
            </a>
            <a class="social_link" href="https://www.linkedin.com/company/american-video-game-league/" target="_blank" @click="findUsOn('linkedin')">
              <i class="sp-ic-sm-in" />
            </a>
            <a class="social_link" href="https://www.facebook.com/AVGLofficial/" target="_blank" @click="findUsOn('facebook')">
              <i class="sp-ic-sm-fb-2" />
            </a>
            <a class="social_link" href="https://twitter.com/AVGLofficial" target="_blank" @click="findUsOn('twitter')">
              <img class="lazyload" :data-src="contentCloudFront('/assets/v4/social_icon/twitter.png')" width="21.781" height="18">
            </a>
            <a class="social_link" href="https://www.tiktok.com/@avglofficial?lang=en" target="_blank">
              <i class="sp-ic-tiktok-icon" />
            </a>
            <a class="social_link" href="https://www.instagram.com/avglofficial/" target="_blank">
              <i class="sp-ic-instagram-icon" />
            </a>
          </template>
          <template v-else>
            <a class="social_link" href="https://www.twitch.tv/boomtv" target="_blank">
              <img class="lazyload" :data-src="contentCloudFront('/assets/v4/social_icon/twitch.png')" width="18" height="18">
            </a>
            <a class="social_link" href="https://discord.gg/kjWVjannCV" target="_blank">
              <img class="lazyload" :data-src="contentCloudFront('/assets/v4/social_icon/discord.png')" width="16.442" height="18">
            </a>
            <a class="social_link" href="https://www.linkedin.com/company/boom.tv" target="_blank" @click="findUsOn('linkedin')">
              <i class="sp-ic-sm-in" />
            </a>
            <a class="social_link" href="https://www.facebook.com/boomtv/" target="_blank" @click="findUsOn('facebook')">
              <i class="sp-ic-sm-fb-2" />
            </a>
            <a class="social_link" href="https://twitter.com/boomtv" target="_blank" @click="findUsOn('twitter')">
              <img class="lazyload" :data-src="contentCloudFront('/assets/v4/social_icon/twitter.png')" width="21.781" height="18">
            </a>
            <a class="social_link" href="https://www.tiktok.com/@boomtvesports" target="_blank">
              <i class="sp-ic-tiktok-icon" />
            </a>
            <a class="social_link" href="https://www.instagram.com/boomtvesports/" target="_blank">
              <i class="sp-ic-instagram-icon" />
            </a>
          </template>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { component } from '../../mixins/component';
import { helper } from '../../mixins/helper';

export default {
  mixins: [component, helper],
  methods: {
    findUsOn(social) {
      // ga('send', 'event', 'Buttons', 'click', 'Find us on '+social);
      // return false;
    },
  },
};
</script>
